export enum EExpand {
    Tariffs = 'tariffs',
    MinPrice = 'minPrices',
    ShopItems = 'shopItems',
    ShopItemsProps = 'shopItems.props',
    RecommendedTariffLines = 'recommendedTariffLines',
    Contents = 'contents',
}
